import React, { useEffect, useRef, useState } from "react";

const AdBanner = () => {
  const ref = useRef(null);
  const [canShowAds, setCanShowAds] = useState(false);

  useEffect(() => {
    const check = () => {
      const g = window.google_tag_data;
      const s = g?.consent?.default_consent_state || {};
      const ok =
        (s.ad_storage === "granted" || s.ad_storage === true) &&
        (s.ad_user_data === "granted" || s.ad_user_data === true);
      setCanShowAds(!!ok);
    };
    check();
    const id = setInterval(check, 1000);
    return () => clearInterval(id);
  }, []);

  useEffect(() => {
    if (!canShowAds || !ref.current) return;
    if (ref.current.getAttribute("data-adsbygoogle-status") === "done") return;
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      console.warn("adsbygoogle push error:", e);
    }
  }, [canShowAds]);

  if (!canShowAds) return null;

  return (
    <ins
      ref={ref}
      className="adsbygoogle"
      style={{ display: "block", minHeight: 250, textAlign: "center", margin: "20px 0" }}
      data-ad-client="ca-pub-2416698434185002"
      data-ad-slot="1388418800"
      data-ad-format="auto"
      data-full-width-responsive="true"
      data-adtest="off"
    />
  );
};

export default AdBanner;
